/*
Solid Surface

--manufacturer <Manufacturer>
--manufacturerNumber <string>
--computerEaseNumber <string>
*/

import { manufacturer } from '@/modules/standardItems/schemas/baseFilters'
import sheetStockFilters from '@/modules/standardItems/schemas/sheetStock/filters'

export default [
  manufacturer(),
  ...sheetStockFilters()
]
